import {Accordion, AccordionDetails, AccordionSummary, Typography} from "@material-ui/core"
import {ExpandMore as ExpandMoreIcon, SmsFailed as SmsFailedIcon} from "@material-ui/icons"
import React from "react"

import {CustomerSMSActivityPayload} from "@indebted/api"

function WelcomeSMSFailedActivity(
	panelId: number,
	{Title, HappenedAt, Payload}: {Title: string; HappenedAt: string; Payload: CustomerSMSActivityPayload},
	expanded: boolean,
	handleExpand: (panelID: number) => (event: any, isExpanded: boolean) => void,
	classes: {summary: string; activityContent: string; activityContentLabel: string; activityContentValue: string},
) {
	return (
		<Accordion expanded={expanded} onChange={handleExpand(panelId)}>
			<AccordionSummary expandIcon={<ExpandMoreIcon />}>
				<SmsFailedIcon color="error" />
				<Typography className={classes.summary}>
					{" "}
					<b>{Title}</b> - {HappenedAt}
				</Typography>
			</AccordionSummary>
			<AccordionDetails>
				{expanded && (
					<div className={classes.activityContent}>
						<div>
							<Typography className={classes.activityContentLabel}>To Number:</Typography>
							<Typography className={classes.activityContentValue}>{Payload.ToNumber}</Typography>
						</div>
						<div>
							<Typography className={classes.activityContentLabel}>Text:</Typography>
							<Typography className={classes.activityContentValue}>{Payload.Text}</Typography>
						</div>
						<div>
							<Typography className={classes.activityContentLabel}>Initiated At:</Typography>
							<Typography className={classes.activityContentValue}>{Payload.InitiatedAt}</Typography>
						</div>
						<div>
							<Typography className={classes.activityContentLabel}>Failed At:</Typography>
							<Typography className={classes.activityContentValue}>{Payload.FailedAt}</Typography>
						</div>
						<div>
							<Typography className={classes.activityContentLabel}>Failed Reason:</Typography>
							<Typography className={classes.activityContentValue}>{Payload.FailedReason}</Typography>
						</div>
					</div>
				)}
			</AccordionDetails>
		</Accordion>
	)
}

export {WelcomeSMSFailedActivity}
